import Enumerable from "linq";
import { IClaioRegistry } from "../../../domain/claio";
import { IExternalImageRegistry } from "../../../domain/externalImage";
import {
  ExecuteRequest,
  ExternalScriptExecuteResult,
} from "../../../domain/localhost/items";
import { IInternalScriptProcessible } from ".";
import { WrapperContainer } from "./internalScripts";
import { ConvertReplacer } from "./internalScripts/ConvertReplacer";
import { ImageDateTimeGetter } from "./internalScripts/ImageDateTimeGetter";
import { ExternalSystemValueGetter } from "./internalScripts/ExternalSystemValueGetter";
import { ValueConverter } from "./internalScripts/ValueConverter";
import { IOcojoRegistry } from "../../../domain/ocojo";
import { IExternalSystemRegistry } from "../../../domain/externalSystem";
import { ProfessionGetter } from "./internalScripts/ProfessionGetter";
import { GeneralReplacer } from "./internalScripts/GeneralReplacer";
import { CurrentDateTimeGetter } from "./internalScripts/CurrentDateTimeGetter";

export class InternalScriptManager {
  constructor(claio: IClaioRegistry, ocojo: IOcojoRegistry, externalImage: IExternalImageRegistry, externalSystem: IExternalSystemRegistry) {
    this._scripts = [
      new WrapperContainer(
        // documaker.scriptingのScriptProcessible派生実装をここで指定.(こちらでライブラリ実装すればDocuMakerCloudでも利用できるのでお願いします.)
      ),
      // 従来の内部script.今後はここじゃなく↑を実装して追加お願いします.既存実装も別途移行予定.(対応完了後に第3者評価してからマージ.)
      new ConvertReplacer(),
      new ImageDateTimeGetter(claio.getClaioRepository(), ocojo.getOcojoRepository(), externalImage.getExternalImageRepository()),
      new ValueConverter(),
      new ExternalSystemValueGetter(externalSystem.getExternalSystemService()),
      new ProfessionGetter(),
      new GeneralReplacer(),
      new CurrentDateTimeGetter(),
    ];
  }

  private readonly _scripts: IInternalScriptProcessible[];

  isProcessible(request: ExecuteRequest): boolean {
    return !!this.findScript(request);
  }

  async process(request: ExecuteRequest): Promise<ExternalScriptExecuteResult> {
    const script = this.findScript(request);
    if (!script) {
      throw new Error("実行できるscriptが存在しません.");
    }
    try {
      return await script.process(request);
    } catch (e) {
      console.warn(e);
      // isCompleteがtrueではないので失敗として判定されるようになっている
      return new ExternalScriptExecuteResult();
    }
  }

  private findScript(request: ExecuteRequest): IInternalScriptProcessible {
    return Enumerable.from(this._scripts)
      .firstOrDefault(s => s.isProcessible(request));
  }
}
